export type ObrigacaoID = 1 | 2;

export const ObrigacaoDescricao: Record<ObrigacaoID, string> = {
  1: 'EFD Contribuições',
  2: 'EFD ICMS / IPI',
};
